'use client';

import { Stack, Typography } from '@mui/material';
import React from 'react';

import { CoreHexIcon } from './CoreHexIcon';
import { CoreItem } from './CoreLaunchPadCard';

interface CoreServiceCardProps {
  item: CoreItem;
}

export const CoreServiceCard = ({ item }: CoreServiceCardProps) => {
  return (
    <Stack
      alignItems={'center'}
      padding={{ xs: '16px 8px', sm: '24px' }}
      gap={3}
      sx={{
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '4px',
        height: '100%',
        backgroundColor: '#0d0e18',
        transition: 'all 0.3s ease',
        '&:hover': {
          borderColor: 'rgba(255, 255, 255, 0.2)',
          transform: 'translateY(-4px)',
        },
      }}>
      <CoreHexIcon icon={item.icon} alt={item.title} />
      <Stack gap={2}>
        {item.title ? (
          <Typography
            component={'h5'}
            variant={'headLarge1'}
            fontSize={{ xs: '14px', sm: '18px' }}
            lineHeight={{ xs: '20px', sm: '24px' }}
            textAlign={'center'}
            color={'#FFFFFF'}>
            {item.title}
          </Typography>
        ) : null}
      </Stack>
    </Stack>
  );
};
